module.exports = __webpack_public_path__ + "img/suit-diamond-fill.ec5d0ebf.svg";